import { gql } from "apollo-boost";

export const CREATE_USER_CONFIRM = gql`
mutation CreateUserConfirm($data: UserConfirmInput!) {
  createUserConfirm(data: $data) {
    id
    name
    lastname
    gender
    phone
    address{
      village
      district
      province
    }
    userType {
      id
      name
      isOpen
    }
  }
}
`
export const DELETE_USER_CONFIRM = gql`
mutation DeleteUserConfirm($where: UserConfirmWhereInputOne!) {
  deleteUserConfirm(where: $where) {
    id
  }
}
`

export const UPDATE_USER_CONFIRM = gql`
mutation UpdateUserConfirm($where: UserConfirmWhereInputOne!, $data: UserConfirmInput) {
  updateUserConfirm(where: $where, data: $data) {
    id
  }
}
`